export function getEndImpersonationCallbackUrl(): string {
  if (process.env.NODE_ENV === 'development') return '/';
  return '/admin/impersonate';
}
